var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" "+_vm._s(_vm.$t("chars"))+": "+_vm._s(_vm.charCount.count)+"/"+_vm._s(_vm.max)+" ("+_vm._s(_vm.charCount.numOfSms)+" SMS) "),(!_vm.lengthOk)?_c('v-alert',{attrs:{"type":"error"}},[_vm._v(" "+_vm._s(_vm.$t("smsTooLong"))+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }